export const classes = [
  {
    name: '11 класс',
    value: '11',
  },
  {
    name: '10 класс',
    value: '10',
  },
  {
    name: '9 класс',
    value: '9',
  },
]
